<template>
  <v-row class="conteudo-aula-infantil">
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Campos de experiências</e-label>
      <div class="d-flex flex-wrap">
        <v-chip
          v-for="(item, i) in camposDeExperiencias"
          :key="i"
          class="ma-1"
          color="primary"
          outlined
        >
          {{ item }}
        </v-chip>
      </div>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium">Eixos temáticos</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.eixos }}</p>
    </v-col>

    <v-col cols="12">
      <e-label class="font-weight-medium">Estratégias de ensino</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.estrategias }}</p>
    </v-col>

    <v-col cols="12">
      <e-label class="font-weight-medium">Recursos</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.recursos }}</p>
    </v-col>

    <v-col cols="12">
      <e-label class="font-weight-medium">Atividade de classe</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.atividade_classe }}</p>
    </v-col>

    <v-col cols="12">
      <e-label class="font-weight-medium">Atividade de casa</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.atividade_casa }}</p>
    </v-col>

    <v-col cols="12">
      <e-label class="font-weight-medium">Observações</e-label>
      <p class="font-weight-regular saltar-linha">{{ aula.observacoes }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ConteudoAulaInfantil",
  props: {
    aula: {
      type: Object,
      required: true,
    },
  },
  computed: {
    camposDeExperiencias() {
      return (this.aula.campos_de_experiencias || []).filter((item) => item !== null);
    },
  },
};
</script>

<style scoped>
.saltar-linha {
  white-space: pre-line;
}
.conteudo-aula-infantil {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}
</style>
